<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <div v-if="ajuizamentos && ajuizamentos.length > 0">
          <b-tabs
            content-class="no-border"
            pills
            style="border: solid 1px #efefef; border-radius: 5px;"
          >
            <b-tab
              v-for="(obj, index) in ajuizamentos"
              :key="index"
              :title="(index + 1).toString()"
              class="no-border"
            >
              <div class="form-group row pr-3 pb-4" style="float: right;">
                <span class="pointer" @click="editAjuizamento(obj)">
                  <i class="fa fa-pen" />
                </span>
              </div>
              <div class="form-group row pt-4">
                <div class="col-md-12">
                  <label><strong>Nº do Processo: &nbsp;</strong></label>
                  {{ obj.numeroProcesso }}
                </div>
                <div class="col-md-12">
                  <label><strong>CNJ: &nbsp;</strong></label>
                  {{ obj.cnj && obj.cnj.replace(/[^\d]/g, "") }}
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Assunto: &nbsp;</strong>
                    <TextTruncate :text="obj.assunto && obj.assunto.nome" />
                  </label>
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Objeto da Ação: &nbsp;</strong>
                    <TextTruncate
                      :text="obj.objetoAcao && obj.objetoAcao.nome"
                    />
                  </label>
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Comarca: &nbsp;</strong>
                    <TextTruncate :text="obj.comarca && obj.comarca.nome" />
                  </label>
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Advogado Responsável: &nbsp;</strong>
                    <TextTruncate :text="obj.advogadoResponsavel" />
                  </label>
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Advogado Contrário: &nbsp;</strong>
                    <TextTruncate :text="obj.advogadoContrario" />
                  </label>
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Prognóstico: &nbsp;</strong>
                    <TextTruncate
                      :text="obj.prognostico && obj.prognostico.nome"
                    />
                  </label>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Valor Causa: &nbsp;</strong></label>
                    {{
                      obj.valorCausa.toLocaleString("pt-Br", {
                        style: "currency",
                        currency: "BRL"
                      })
                    }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Valor Causa 2: &nbsp;</strong></label>
                    {{
                      obj.valorCausa2.toLocaleString("pt-Br", {
                        style: "currency",
                        currency: "BRL"
                      })
                    }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Data Distribuição: &nbsp;</strong></label>
                    {{
                      obj.dataDistribuicao && formatDate(obj.dataDistribuicao)
                    }}
                  </div>
                </div>
                <div class="col-md-12 input-group">
                  <label>
                    <strong>Fase: &nbsp;</strong>
                    <TextTruncate :text="obj.fase && obj.fase.nome" />
                  </label>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Último Andamento: &nbsp;</strong></label>
                    {{ obj.ultimoAndamento && formatDate(obj.ultimoAndamento) }}
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else>
          Nenhum registro encontrado.
        </div>
      </div>
    </div>
    <ModalAjuizamento
      ref="ModalAjuizamento"
      :ajuizamento="ajuizamento"
      @Reload="onReload"
    />
  </div>
</template>
<script>
import CrmDetailsAjuizamento from './ajuizamento.js'
export default CrmDetailsAjuizamento
</script>
<style lang="scss">
.nav.nav-pills {
  li.nav-item {
    margin-bottom: 0.2rem;
  }
}
</style>
<style scoped>
.no-border {
  border: 0px;
}

.tab-content {
  border: 0px solid #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/ajuizamento/ajuizamento.vue